import { MetricDirection } from '../data/types';

/**
 * @description scales zscore
 * @param score
 * @returns
 */
export const scaleZScore = (score: number): number => {
  if (score === -4) return 0;
  if (score === 4) return 100;

  return Math.round(((4 + score) / 8) * 100);
};

/**
 * @description calculates zscore
 * @param value
 * @param mean
 * @param sd
 * @param direction
 * @returns
 */
export const zScore = (
  value: number,
  mean: number,
  sd: number,
  direction: MetricDirection
): number => {
  const leftOperand = differenceFromMean(value, mean, direction);
  const rightOperand = direction === 0 ? Math.abs(sd) : sd;
  const score = leftOperand / rightOperand;
  if (score >= 4) {
    return 4;
  }
  if (score <= -4) {
    return -4;
  }
  return score;
};

/**
 * @description calculates difference from mean accounting for metric direction
 * @param value
 * @param mean
 * @param direction
 * @returns
 */
export const differenceFromMean = (
  value: number,
  mean: number,
  direction: MetricDirection
): number => {
  switch (direction) {
    case 0:
      /// use absolute
      return Math.abs(mean - value);
    case -1:
      if (value < 0 && mean < 0) {
        return Math.abs(value) - Math.abs(mean);
      } else {
        const invertedValue = value > 0 ? -value : value;
        const invertedMean = mean > 0 ? -mean : mean;
        return invertedValue - invertedMean;
      }

    case 1:
      return value - mean;
    default:
      return value - mean;
  }
};
